export const DREAM_TOUR_PROMOTION_NAME = 'lottery';

export const DREAM_TOUR_PROMOTION_CREATIVE = 'lottery__banner-mobile';

export const DREAM_TOUR_PROMOTION_POSITION = 'search';
